// Styles
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const appTheme = {
  dark: true,
  colors: {
    background: "#131515",
    jade: "#2BAE66",
    payneGray: "#57737A",
    butter: "#FFFFD2",
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "appTheme",
    themes: {
      appTheme,
    },
  },
});
